const TYPE = {
    HEARTRATE: 1,
    RESPIRATION: 2,
    TEMPERATURE: 3,
    WEIGHT: 4,
    CAPILLARY: 6
};

export default {
    TYPE
};
